<div [hidden]="isSessionActive && embed()">
  <div class="d-flex mb-4 flex-column align-items-start flex-lg-row align-items-lg-end mt-2">
    <h4 class="me-2 mb-0">{{ 'orderProcess.payment.contactForm.title' | translate }}</h4>
    <div class="text-primary cursor-pointer font-md d-none d-sm-block"
         [translate]="'orderProcess.payment.whyDoAskInfo.question'"
         [ngbTooltip]="'orderProcess.payment.whyDoAskInfo.answer' | translate">
    </div>
  </div>

  <payment-contact-info-b
    [userInfo]="info"
    [countryCode]="countryCode()"
    [personType]="personType()"
    [bakeryId]="bakeryId()"
    [useCompanySearcher]="useCompanySearcher()"
    (onInfoUpdated)="infoUpdated($event)"
    (onValidUpdated)="isValid = $event"
    (onCompanySelected)="onCompanySelected.emit($event)"
  ></payment-contact-info-b>

  <ng-content select=".gift-card-and-promo-code"></ng-content>

  <ng-content select=".payment-method-selector"></ng-content>

  @if (!hidePaymentMethodFields()) {
    @if (personType() === PAYMENT_PERSON_TYPES.COMPANY) {
      <order-reference-input
        class="d-block mt-4"
        [reference]="info?.reference"
        (referenceChange)="infoUpdated({ reference: $event })"
      ></order-reference-input>
    }

    <button class="btn btn-pink payment-confirm-btn my-4"
            [disabled]="!isValid"
            (click)="confirm($event)">
      {{ 'orderProcess.payment.goToPayment' | translate }}
    </button>

    <terms-and-conditions
      (onTermsClick)="onTermsClick.emit()"
    ></terms-and-conditions>
  }
</div>

<div class="position-relative"
     [hidden]="!isSessionActive || !embed()">
  <ui-back-button class="d-block mb-4" (onClick)="cancelSession()" [showTextOnlyOnDesktop]="false"
                  [translateKey]="'orderProcess.payment.bambora.backToContactDetails'"></ui-back-button>
  <div class="embed-container" #embedContainer>
  </div>
</div>

<div class="dintero-modal-backdrop"
     [hidden]="!isSessionActive || embed()">
  <div class="dintero-modal-dialog">
    <div class="dintero-modal-container" #modalContainer>
    </div>

    <button type="button" class="btn btn-link d-block mx-auto mb-3" (click)="cancelSession()">
      {{ 'common.cancel' | translate }}
    </button>
  </div>
</div>
